import $ from 'jquery';

/**
 * Levels:
 *  - primary
 *  - secondary
 *  - success
 *  - danger
 *  - warning
 *  - info
 *  - light
 *  - dark
 */
export const addAnnouncement = ({
  id = 'announcement-default',
  level = 'info',
  title = '',
  message = '',
}) => {
  if (!title && !message) {
    throw new Error('Cannot addAnnouncement: Empty title and message');
  }

  const alreadyExists = $(`#${id}`).length > 0;

  if (alreadyExists) {
    return;
  }

  let announcementHtml = `<div id="${id}" class="alert alert-${level}" role="alert">`;

  if (title) {
    announcementHtml += `<p class="lead font-bold"><strong>${title}</strong></p>`;
  }

  if (message) {
    announcementHtml += `<p class="lead">${message}</p>`;
  }

  announcementHtml += '</div>';

  $('.layout-announcements').append(announcementHtml);
};

export const addAdminLoginAnnouncement = () => {
  const params = {
    id: 'announcement-admin-top',
    title: 'Da grandi poteri derivano grandi responsabilità',
    message:
      'Sei loggato come Global Editor. Ogni modifica può avere un impatto su tutti gli utenti, mi raccomando, fai attenzione!',
    level: 'warning',
  };
  addAnnouncement(params);
};
